import React from 'react';
import { Button } from '@welbe/design-system';

import {
	ErrorText,
	ModalContainer,
	UploadFiles,
	Paragraph,
} from '@welbe/web-design-system';
import useUploadCsv from './ModalUploadCsv.hook';

import {
	Container,
	Title,
	Description,
	ContainerUpload,
	ContainerButton,
} from './ModalUploadCsv.style';

import { ReactComponent as CandidateSvg } from 'App/assets/img/candidate.svg';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';

export type OriginUploadCsvType = 'employees' | 'candidates' | 'jobProfile';

export interface ModalUploadCsvProps {
	isOpen: boolean;
	origin: OriginUploadCsvType;
	onClose?: () => void;
	onSuccess?: () => void;
}

export const ModalUploadCsv = ({
	isOpen,
	origin,
	onClose,
	onSuccess,
}: ModalUploadCsvProps): JSX.Element => {
	const renderTitle = () => {
		if (origin === 'employees' || origin === 'jobProfile') {
			return 'Agregar colaboradores';
		}
		if (origin === 'candidates') {
			return 'Agregar candidatos';
		}
		return 'Agregar CSV';
	};

	const {
		csvFile,
		isLoading,
		isBroker,
		errorMessage,
		handleFile,
		hasError,
		handleSubmit,
		handleDownloadEmployeeExemple,
	} = useUploadCsv({ onClose, onSuccess, origin });

	useAnalyticsOpenScreen({
		context: 'app',
		trackName: 'Initiate Upload CSV',
		analyticProps: { isBroker },
	});

	const RenderBody = () => {
		if (origin === 'employees') {
			return (
				<Container>
					<Title>{renderTitle()}</Title>
					<Description>Agrega un archivo CSV desde tu ordenador</Description>
					<ContainerUpload>
						<UploadFiles
							fileName={csvFile?.name || ''}
							onHandleFile={handleFile}
							acceptedFileTypes={['text/csv']}
						/>
						{hasError && <ErrorText>{errorMessage}</ErrorText>}
					</ContainerUpload>
					<ContainerButton>
						<Button loading={isLoading} onClick={handleSubmit}>
							Confirmar
						</Button>
					</ContainerButton>
				</Container>
			);
		}
		if (origin === 'candidates') {
			return (
				<Container>
					<Title>{renderTitle()}</Title>
					<Description>Agrega un archivo CSV desde tu ordenador</Description>
					<ContainerUpload>
						<UploadFiles
							fileName={csvFile?.name || ''}
							onHandleFile={handleFile}
							acceptedFileTypes={['text/csv']}
						/>
						{hasError && <ErrorText>{errorMessage}</ErrorText>}
					</ContainerUpload>
					<ContainerButton>
						<Button loading={isLoading} onClick={handleSubmit}>
							Confirmar
						</Button>
					</ContainerButton>
				</Container>
			);
		}
		if (origin === 'jobProfile') {
			return (
				<Container>
					<Title>{renderTitle()}</Title>
					<div>
						<Paragraph padding="0 0 10px 0">
							1. Descarga el siguiente archivo
						</Paragraph>
						<Button onClick={handleDownloadEmployeeExemple} variant="outline">
							colaboradores.csv
						</Button>
					</div>
					<Paragraph padding="0 0 10px 0">
						2. Llena cuidadosamente el formato
					</Paragraph>
					<Paragraph>3. Sube el archivo en formato .csv</Paragraph>

					<ContainerUpload id="test">
						<UploadFiles
							fileName={csvFile?.name || ''}
							onHandleFile={handleFile}
							acceptedFileTypes={['text/csv']}
						/>
						{hasError && <ErrorText>{errorMessage}</ErrorText>}
					</ContainerUpload>
					<ContainerButton>
						<Button variant="outline" loading={isLoading} onClick={onClose}>
							Cancelar
						</Button>
						<Button loading={isLoading} onClick={handleSubmit}>
							Confirmar
						</Button>
					</ContainerButton>
				</Container>
			);
		}
		return <Description>Agrega un archivo CSV desde tu ordenador</Description>;
	};

	return (
		<ModalContainer
			headerIcon={<CandidateSvg />}
			onClose={onClose}
			visible={isOpen}
			height={300}
			hasCloseButton
			closeOnlyOnTheButton
			zIndex={1200}
		>
			<RenderBody />
		</ModalContainer>
	);
};
